import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary.js';
import { queryClient } from './queryClient.js';
import { router } from './routes.js';
import { ThemeRoot } from './ThemeRoot.js';

export const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ThemeRoot>
        <RouterProvider router={router} />
      </ThemeRoot>
    </QueryClientProvider>
  </ErrorBoundary>
);
